<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1034235" style="color: #82a339"><b>HOT CRABMEAT SPREAD</b></p>
<p class="ext" id="d7e1034735"><b><i>The topping of sliced almonds adds another layer of rich flavor and an unexpected crunch to this crowd-pleasing spread.</i></b></p>
<p class="h4" id="d7e1036035" style="color: #496210"><b>Prep: 10 minutes     Bake: 22 minutes</b></p>
<p class="ul" id="d7e1036535">3 tablespoons sliced almonds</p>
<p class="ul" id="d7e1036835">1 container (8 ounces) lump crabmeat</p>
<p class="ul" id="d7e1037135">1 package (8 ounces) cream cheese, softened</p>
<p class="ul" id="d7e1037435">3 tablespoons minced onion</p>
<p class="ul" id="d7e1037735">1 tablespoon milk</p>
<p class="ul" id="d7e1038035">½ teaspoon prepared white horseradish</p>
<p class="ul" id="d7e1039035">¼ teaspoon salt</p>
<p class="ul" id="d7e1039935">⅛ teaspoon coarsely ground black pepper <br/> assorted crackers</p>
<p class="pub" id="d7e1041435" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Preheat oven to 375°F. Spread almonds in 8-inch square metal baking pan. Bake 2 to 3 minutes or until lightly toasted. Pick through crabmeat to remove any pieces of shell, making sure not to break up meat.</p>
<p class="pub" id="d7e1043135"><span style="color: #c15b49"><b>2.</b></span> In bowl, stir cream cheese, onion, milk, horseradish, salt, and pepper until blended. Gently stir in crabmeat. Spread mixture into shallow 9-inch ceramic or glass baking dish.</p>
<p class="pub" id="d7e1044835"><span style="color: #c15b49"><b>3.</b></span> Sprinkle almonds over crabmeat mixture. Bake 20 to 25 minutes or until edges brown and center begins to bubble. Serve hot with crackers. Makes about 12 servings.</p>
<p class="ntx" id="d7e1046735">Each serving: About 40 calories, 2g protein, 1g carbohydrate, 3g total fat (2g saturated), 0mg fiber, 17mg cholesterol, 70mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c20_r1.vue?ebffd286